import fi_lcw from './fi_lcw';
import no_lcw from './no_lcw';
import se_lcw from './se_lcw';

import fi_mbl1 from './fi_mbl1';
import no_mbl1 from './no_mbl1';
import se_mbl1 from './se_mbl1';
import dk_mbl1 from './dk_mbl1';

import is from './is';
import en from './en';
import fr_be from './fr_be';
import nl_be from './nl_be';

import de from './de';
import en_eg from './en_eg';
import en_gb from './en_gb';
import en_med from './en_med';
import en_mid from './en_mid';
import fr_fr from './fr_fr';
import it_it from './it_it';
import pl from './pl';
import ru from './ru';
import tr_tr from './tr_tr';
import ua_ua from './ua_ua';

export default {
  fi_lcw,
  no_lcw,
  se_lcw,
  fi_mbl1,
  no_mbl1,
  se_mbl1,
  dk_mbl1,
  is,
  en,
  fr_be,
  nl_be,
  de,
  en_eg,
  en_gb,
  en_med,
  en_mid,
  fr_fr,
  it_it,
  pl,
  ru,
  tr_tr,
  ua_ua
};
